import { Group, Radio, Tooltip, ActionIcon } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { AvailabilityType, AvailabilityTypeEnum } from '@bariendo/lib/scheduling';

interface AvailabilityTypeInputProps {
  value: AvailabilityType;
  onChange: (value: AvailabilityType) => void;
}

export function AvailabilityTypeInput({ value, onChange }: AvailabilityTypeInputProps) {
  return (
    <Radio.Group value={value} onChange={(val) => onChange(val as AvailabilityType)}>
      <Group>
        <Radio label="Weekly (Recurring)" value={AvailabilityTypeEnum.WEEKLY} size="xs" />
        <Group gap={4}>
          <Radio label="One time" value={AvailabilityTypeEnum.ONETIME} size="xs" />
          <Tooltip label="One-time availability overrides weekly availability when they overlap.">
            <ActionIcon variant="subtle" color="gray" size="xs">
              <IconInfoCircle size={16} />
            </ActionIcon>
          </Tooltip>
        </Group>
      </Group>
    </Radio.Group>
  );
}
